import script from "./InfoDeleteAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoDeleteAccount.vue?vue&type=script&setup=true&lang=ts"

import "./InfoDeleteAccount.vue?vue&type=style&index=0&id=5971cba9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5971cba9"]])

export default __exports__